// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"MdSz2","checkbox":"nKGAH","infoIcon":"_KSho"};